// modules
import { createAction } from 'redux-actions'

export const setCaseManagersList = createAction('SET_CASE_MANAGERS_LIST')
export const setCaseManagersListLoader = createAction(
  'SET_CASE_MANAGERS_LIST_LOADER'
)

export const setCaseManagersModalLoader = createAction(
  'SET_CASE_MANAGERS_MODAL_LOADER'
)
